import userstories from './userstories'
import app from './app'
import { storeModule as stages } from './stages'

export default {
  userstories,
  app,
  stages
}
